import { render, staticRenderFns } from "./ReelModal.vue?vue&type=template&id=65fda29c&scoped=true"
import script from "./ReelModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReelModal.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ReelModal.vue?vue&type=style&index=0&id=65fda29c&prod&lang=scss"
import style1 from "./ReelModal.vue?vue&type=style&index=1&id=65fda29c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65fda29c",
  null
  
)

export default component.exports